import {
    CheckCircleFilled,
    DownloadCircleFilled,
    DownloadOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { DownloadableItem, DownloadableItemSource } from 'types';
import { isSample } from 'types/typeGuards/isSample';

export const getDownloadIcon = (
    isDownloaded: boolean,
    isDAWPlugin: boolean,
) => {
    if (isDAWPlugin) {
        return isDownloaded ? CheckCircleFilled : DownloadOutlined;
    } else {
        return isDownloaded ? DownloadCircleFilled : DownloadOutlined;
    }
};

export const getDownloadLabel = (
    item: DownloadableItemSource,
    downloadableItem: DownloadableItem,
    isDAWPlugin: boolean,
    label: string,
) => {
    if (isDAWPlugin) {
        if (downloadableItem.isDownloaded) {
            return t`Added to downloads`;
        } else {
            const isFree = isSample(item) && item?.credits === 0;

            return isFree ? t`Add to downloads` : t`Buy and add to downloads`;
        }
    } else {
        const credits = isSample(item) ? item?.credits : undefined;

        const dynamicLabel =
            isSample(item) &&
            item?.credits !== null &&
            item?.credits !== undefined &&
            !downloadableItem.isDownloaded
                ? t`Download - ${credits} credit`
                : label;

        return dynamicLabel;
    }
};
